import '../../css/mk-brand.css';
import React, {useEffect} from "react";

function Panel() {
    useEffect(() => {}, );
    return (
        <div id="super-og-info" className="m-2">
            <div className="container bg-zinc-800 pt-4 px-4 md:px-32 pb-4 rounded-lg max-w-4xl">
                <div className="flex flex-row">
                    <div className="max-w-2xl mx-auto mb-10">
                        <div className="flex-row">
                            <div>
                                <div className="flex">
                                    <span className="text-5xl md:text-6xl lg:text-5xl font-bold text-brand">
                                      Super<span className="text-brand-text">OG </span>
                                    </span>
                                </div>
                                <div className="text-brand-text text-2xl text-right cursor-pointer hover:font-bold">
                                    <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/the-menu/game-mechanics/ready-set-whip">
                                        mini-game
                                    </a>
                                </div>
                                <div className="border border-brand" />
                            </div>
                        </div>
                        <p className="mb-6 mt-6 text-white md:text-2xl">
                            As an appetizer, use your new OG Chef NFTs in a 3 round, winner take all, chef show down.
                        </p>
                        <ul className="list-disc ml-6 md:text-2xl">
                            <li><b>Champion a Challenge:</b> Create your own challenge by entering a challenge amount in $CHEF coin or $SOL, then select three OG chefs from your wallet to play.</li>
                            <li><b>Challenge a Champion:</b> Browse the challenges, accept one that fits your budget, then select three OG chefs from your wallet to play.</li>
                            <li><b>Battle:</b> launch a 100% on-chain <span className="text-brand font-extrabold">Super</span><b>OG</b> Solana blockchain battle.</li>
                            <li><span className="font-extrabold">OG Revenue Sharing:</span>&nbsp;<span>All metaKitchen game fees will be redistributed to the OG Chefs through $SOL Giveaways, NFT Raffles, and Airdrops.</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Panel;